export enum TermsOfUseType {
  TERM_OF_USE = 'TU',
  TERM_OF_CONSENT = 'TC',
}
